import { Alert, Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";
import { loginWithPassword } from "../services/authService";

/** Poslední krok přihlášení ověřeným e-mailem. */
export default function EmailPasswordPage() {
  const { state } = useLocation();
  const cisloOdberatele = state?.cisloOdberatele;
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { setAccessToken } = useAuth();

  useEffect(() => {
    if (!cisloOdberatele) navigate("/login", { replace: true });
  }, [cisloOdberatele, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const result = await loginWithPassword(cisloOdberatele, password);
      if (!result.success || result.mfaRequired) {
        setError(result.message || "Přihlášení se nezdařilo.");
        return;
      }
      setAccessToken(result.token);
      navigate("/zvk", { replace: true });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", my: 2 }}>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>Zadejte heslo</Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        E-mail je ověřen. Zadejte heslo pro odběratele {cisloOdberatele}.
      </Alert>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box component="form" onSubmit={handleSubmit}>
        <TextField label="Heslo" type="password" value={password}
          onChange={(event) => setPassword(event.target.value)} disabled={isSubmitting}
          fullWidth required autoComplete="current-password" />
        <Button type="submit" variant="contained" disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : undefined}
          sx={{ display: "block", mx: "auto", mt: 2, width: 200 }}>
          {isSubmitting ? "Přihlašuji…" : "Přihlásit se"}
        </Button>
      </Box>
    </Box>
  );
}
